<div class="key-papers">
  <div>
    <span (click)="toggleCollapseClickHandler()">
      <i class="fa centered-icon text-primary-dark" [ngClass]="showList ? 'fa-angle-down' : 'fa-angle-right'"></i>
      <span class="attachments-title">
        <span class="bold text-uppercase">KEY PAPERS</span> ({{keyPapersList?.length || 0}})
      </span>
    </span>
    <ng-container *ngIf="keyPapersList?.length">
      <span class="ml-3" *ngFor="let attachment of keyPapersList | slice: 0: 3" (click)="downloadAttachment(attachment)">
        <i class="fa fa-{{attachment.fileType?.className}}" [ngStyle]="{'color': attachment.fileType?.color}"></i>
        {{attachment.fileName.substring(0, 10)}}{{attachment.fileName.length > 10 ? '...' : null}}
        {{attachment.createdBy.firstName + ' ' + attachment.createdBy.lastName}} - {{attachment.created | rmsTzFormat: undefined: dateFormat}}
      </span>
    </ng-container>
  </div>
  <div *ngIf="hasPermission.coreAttachmentsCreate">
    <label class="btn btn-outline-teal mr-1 mr-md-3 file-import-field float-right">
      <input type="file" id="fileUploadField"
             [accept]="allowedFileType"
             (change)="inputFileChanged($event.target.files) //noinspection UnresolvedVariable"
             rmsOfflineDisable>
      UPLOAD NEW
    </label>
    <ng-container *ngIf="fileUploadService.fileUploadProgress > 0 && uploadingKeyPapers">
      <span [innerHTML]="fileUploadService.uploadMessage"></span>
      <p style="max-width: 280px">
        <ngb-progressbar type="info" [value]="fileUploadService.fileUploadProgress" height="10px"></ngb-progressbar>
      </p>
    </ng-container>
  </div>
</div>

<div class="key-papers-list" *ngIf="showList">
  <ul class="attachments-list" *ngIf="keyPapersList?.length; else noContent">
    <li *ngFor="let attachment of keyPapersList" class="p-2 pl-3">
      <div class="row">
        <div class="col-auto pr-0">
          <span class="fake-link" (click)="downloadAttachment(attachment)">
            <i class="fa fa-{{attachment.fileType?.className}}" [ngStyle]="{'color': attachment.fileType?.color}"></i>
            {{attachment.fileName}}
          </span>
        </div>
        <div *ngIf="attachment.createdBy" class="col-auto">
          <span class="text-primary-dark">
            {{attachment.createdBy.firstName + ' ' + attachment.createdBy.lastName}} - {{attachment.created | rmsTzFormat: undefined: dateFormat}}
          </span>
        </div>
      </div>
    </li>
  </ul>
  <rms-loading-spinner *ngIf="loadingKeyPapersList"></rms-loading-spinner>
  <ng-template #noContent>
    <rms-no-content></rms-no-content>
  </ng-template>
</div>
